<template>
  <div class="ticket-info">
    <h6>Ticket Information</h6>
    <div>
      <div class="ticket-label">
        <md-field class="md-form-group">
          <md-icon
            ><i class="fas fa-tag text-primary hi-price-icon"></i
          ></md-icon>
          <span v-if="traveller.ticket" class="traveller-ticket">{{
            traveller.ticket.title
          }}</span>
          <span v-else class="traveller-ticket">No Ticket Selected</span>
        </md-field>
      </div>

      <div v-if="traveller.ticket" class="ticket-price">
        <md-field class="md-form-group" slot="inputs">
          <md-icon
            ><i
              :class="currencyClass"
              class="fas text-primary hi-price-icon"
            ></i
          ></md-icon>
          <label>Ticket Price</label>
          <md-input
            v-model="traveller.departure_price"
            v-on:change="evt => this.$emit('priceOveride', traveller, evt)"
            type="text"
          ></md-input>
          <md-icon class="price-info text-primary">
            help
            <md-tooltip md-direction="right"
              >Set the Ticket price for
              {{ traveller.user_info.full_name }}</md-tooltip
            >
          </md-icon>
        </md-field>
      </div>

      <div class="ticket-action">
        <a href="#" @click.prevent="showTicketDialog = true">Select Ticket</a>
      </div>
    </div>

    <booking-ticket-availability
      :showTicketDialog="showTicketDialog"
      :booking="booking"
      :traveller="traveller"
      :ticketTypes="ticketTypes"
      @ticketSelected="ticketSelected"
      @cancelled="showTicketDialog = false"
    ></booking-ticket-availability>
  </div>
</template>
<script>
import BookingTicketAvailability from "./BookingTicketAvailability.vue";
import _filter from "lodash/filter";

export default {
  props: ["booking", "traveller", "ticketTypes"],

  data() {
    return {
      showTicketDialog: false,
      selectedTicket: null
    };
  },

  components: {
    BookingTicketAvailability
  },

  methods: {
    ticketSelected(traveller, ticketType) {
      this.showTicketDialog = false;
      this.$emit("ticketSelected", traveller, ticketType);
    }
  },

  computed: {
    currencyClass: function() {
      let currClass = null;
      switch (this.booking.currency) {
        case "gbp":
          currClass = "fa-pound-sign";
          break;
        case "usd":
          currClass = "fa-dollar-sign";
          break;
        case "eur":
          currClass = "fa-euro-sign";
          break;
      }
      return currClass;
    }
  }
};
</script>
<style lang="scss" scoped>
.ticket-info {
  border-radius: 7px;
  background-color: #f6f6f6;
  padding: 10px;
  margin-top: 15px;
  margin-bottom: 30px;

  h6 {
    margin-top: 0;
    margin-bottom: 5px;
  }

  .price-info {
    font-size: 15px !important;
  }

  .ticket-action {
    text-align: right;
    font-size: 14px;
  }

  .ticket-label {
    &::v-deep .md-icon {
      margin: 0px !important;
      margin-right: 12px !important;
    }
    &::v-deep .md-field:after {
      height: 0 !important;
    }
  }
}
</style>
